import { render, staticRenderFns } from "./contact-select.vue?vue&type=template&id=48ba1a4e&scoped=true"
import script from "./contact-select.vue?vue&type=script&lang=js"
export * from "./contact-select.vue?vue&type=script&lang=js"
import style0 from "./contact-select.vue?vue&type=style&index=0&id=48ba1a4e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba1a4e",
  null
  
)

export default component.exports